import { render, staticRenderFns } from "./InstagramLoginCard.vue?vue&type=template&id=047e2c32"
import script from "./InstagramLoginCard.vue?vue&type=script&lang=ts"
export * from "./InstagramLoginCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports